import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Плоская сумка через плечо из габардина. На всю поверхность сумки, включая ручки, можно нанести любой желаемый принт. Размеры: ширина 38 см, длина 42 см. Легко сворачивается и занимает мало места. Длина ручек позволяет носить ее как в руке, так и на плече.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${maintenance}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
